// SCOPE-BADGE: „ügyfél szintű" / „fiók szintű" — a hozzárendelés hatóköre, IKONOSAN.
//
// MIÉRT BADGE (és miért nem halvány szöveg): a hatókör ÜZLETI különbség, nem lábjegyzet — egy ügyfél-szintű
// hozzárendelés az ügyfél ÖSSZES (vagy kijelölt) fiókjára hat, a fiók-szintű pontosan egyre. A user
// kérése: a névsor alatt badge álljon, az ikon pedig ELÖL, hogy a sor egy pillantással olvasható legyen.
//
// A JEL (semleges tónus + aktatáska / épület ikon) a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`,
// `scope` fogalom) — így a hozzárendelés-lista, a számla-űrlap és a bevétel-előrejelzés drilldownja ugyanazt
// mutatja. Ez a fájl csak a kényelmes, névre szóló API-t tartja meg.
import { DomainBadge } from './domain-badge';

export function ScopeBadge({
  scope,
  label,
  className,
}: {
  /** `client` = ügyfél szintű · `account` = fiók szintű (bármi más → semleges tónus, a nyers érték felirattal). */
  scope: string;
  /** A lokalizált címke — a hívó adja (a komponens i18n-agnosztikus, mint a többi shared badge). */
  label: string;
  className?: string;
}): JSX.Element {
  return <DomainBadge kind="scope" value={scope} label={label} className={className} />;
}
